export * from '@fhs/routing/src/routes/(drawer)/account/gift-cards/_layout';
export { default } from '@fhs/routing/src/routes/(drawer)/account/gift-cards/_layout';
